module.exports = __webpack_public_path__ + "static/media/12.2e2dbaf0.png";